import { organisationConstants } from '../../../_constants/organisation.constants';

const initialState = { uploaded_assessment_responses_result_view_loading : true, uploaded_assessment_responses_result_view_data: '', uploaded_assessment_responses_result_view_error_data : '', uploaded_assessment_responses_result_view_error: false};

export function uploadAssessmentResponsesResultView(state = initialState, action) {
    switch (action.type) {
      case organisationConstants.REQUEST_UPLOAD_ASSESSMENT_RESPONSES_RESULT_VIEW_API:
        return {
            uploaded_assessment_responses_result_view_loading: true,
            uploaded_assessment_responses_result_view_data: '',
            uploaded_assessment_responses_result_view_error_data: '',
            uploaded_assessment_responses_result_view_error: false
        };
      case organisationConstants.RECIEVE_UPLOAD_ASSESSMENT_RESPONSES_RESULT_VIEW_API:
        return {
            uploaded_assessment_responses_result_view_loading: false,
            uploaded_assessment_responses_result_view_data: action.uploaded_assessment_responses_result_view.data,
            uploaded_assessment_responses_result_view_error_data: '',
            uploaded_assessment_responses_result_view_error: false
        };
      case organisationConstants.ERROR_UPLOAD_ASSESSMENT_RESPONSES_RESULT_VIEW_API:
        return { 
            uploaded_assessment_responses_result_view_loading: false,
            uploaded_assessment_responses_result_view_data: '',
            uploaded_assessment_responses_result_view_error_data: action.error.response.data.message,
            uploaded_assessment_responses_result_view_error: true
        };
      default:
        return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/organisation/uploadCsv/uploadAssessmentResponsesResultView.reducer.js